import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter ,ModalHeader } from '@momentum-ui/react';
import {i18n} from '../../../utils/GadgetUtils'

  function AlertModal({unSavedChanges, ButtonClick, setButtonClick, continueWithoutSave, setContinueWithoutSave}) {
  const [showModal, setShowModal] = useState(false);
  let modal3;
  
  var modalHeader = i18n.getMsg('gadget.callcontrol.nonvoice.callvariable.modal.header');
  var modalBody = i18n.getMsg('gadget.callcontrol.nonvoice.callvariable.modal.body');
  var cancelButton = i18n.getMsg('gadget.callcontrol.nonvoice.callvariable.modal.cancel');
  var continueButton = i18n.getMsg('gadget.callcontrol.nonvoice.callvariable.modal.continue')


  useEffect(() => {
    setShowModal(unSavedChanges);
  },[unSavedChanges])


  return (
    <div id='modalAlert'>
    <Modal
         applicationId='app'
         onHide={() => {setShowModal(false)}}
         show={showModal}
   ref={node => modal3 = node}
         size='dialog'
         htmlId='modal3'>
         <ModalHeader
           headerLabel={modalHeader}
           showCloseButton
         />
         <ModalBody>
           <div>
     <p> {modalBody} </p>
     </div>
         </ModalBody>
         <ModalFooter>
           <Button
             id='imi-call-var-cancel' 
             children={cancelButton}
             onClick={() => {
              setButtonClick(false);
              modal3.closeModal();
             }}
             ariaLabel='Close Modal'
             color='default'/>
           <Button
             children={continueButton}
             type='submit'
             onClick={(e) => {
              setButtonClick(false);
              modal3.closeModal();
              setContinueWithoutSave(true);
             }}
             ariaLabel='Submit Form'
             color='blue'/>
         </ModalFooter>
       </Modal>
   </div>			
  )
}

export default AlertModal

